exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".info-box,.info-box-narrow{padding:0;font-size:.875rem}.info-box-narrow li a,.info-box li a{text-decoration:underline;color:#545454;font-weight:600}.info-box-narrow li a:active,.info-box-narrow li a:focus,.info-box-narrow li a:hover,.info-box li a:active,.info-box li a:focus,.info-box li a:hover{text-decoration:none}@media (min-width:768px){.info-box,.info-box-narrow{display:inline-block}}.info-box-title{padding:10px 0 2px;margin-left:0;font-weight:500;font-size:large;border-bottom:1px solid #444;color:#545454}.info-box-list{padding-top:5px;font-weight:400;list-style-type:none}.info-box-list li{background-repeat:no-repeat;padding-left:20px;position:relative}.info-box-list li .check{position:absolute;left:0;top:5px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/InfoBox/InfoBox.scss
 ** module id = 1200
 ** module chunks = 0
 **/